<script setup>
const rule = useRobotsRule();
rule.value = "noindex, nofollow";

const router = useRouter();

const form = ref({
  username: "",
  password: "",
});

const bg = ["bg-gradient-to-r", "from-primary-100", "to-white"];

const site = useState("site");
const user = useState("user");

const closed = () => {
  useNotification().Notification.warning({
    title: "报名已结束",
  });
};

const { handleSubmit } = useSubmit("/api/auth/login", "/app", {
  afterSubmit: (id, res) => {
    user.value = res.user;
    router.push("/app");
  },
});

const doSubmit = async () => {
  await handleSubmit(form.value);
};
</script>

<template lang="pug">
WebLayout
  WebSectionTitle 赛队登录
  AppContainer
    .flex-col.-mx-2.flex.my-8(class="md:flex-row md:items-stretch")
      nuxt-link(to="/signup", custom, v-slot="{ navigate }")
        div.cursor-pointer.border.rounded-xl.mx-2.flex-1.flex.flex-col.justify-center.items-center(
          :class="[...bg, 'py-12', 'md:py-4', 'my-4', 'md:my-0']",
          @click="site.isSignupOpen ? navigate() : closed()"
        )
          nuxt-icon.text-4xl(name="user-plus", filled)
          .text-2xl 赛队注册
      .bg-white.border.rounded-xl.mx-2.flex-1.box-border.p-8
        .underline.decoration-4.decoration-primary-400.text-2xl.mb-8 赛队登录
        a-form(@submit.prevent="doSubmit")
          FormLabel(label="用户名")
            a-input.w-full(v-model="form.username", required-mark)
          FormLabel(label="密码")
            a-input.w-full(v-model="form.password", type="password", required-mark)
          a-button.w-full(size="large", type="primary", @click="doSubmit") 登录
</template>
